import type { Quote } from "../../types";
import { ActionsWithoutQdpDrawer } from "./ActionsWithoutQdpDrawer";
import { QuoteActions as Control } from "./QuoteActions";
import { variants } from "../../variants";

export type QuoteActionsProps = {
  quote: Quote;
  variant?: string;
};

export const QuoteActions = ({ quote, variant }: QuoteActionsProps) => {
  const isUKVariant = variants(variant);

  if (isUKVariant) {
    return <ActionsWithoutQdpDrawer quote={quote} />;
  }

  return <Control quote={quote} />;
};
